import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { CustomCacheRequest, SocialType, SortRequest, WithArchiveRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type PaymentMethod = 'card' | 'cash';
export const paymentMethodMap: Record<PaymentMethod, string> = {
  card: 'Карта',
  cash: 'Наличные',
};

export type BranchType = {
  address: LangType;
  address_verified: boolean;
  created_at: string;
  description: LangType;
  id: number;
  is_deleted?: boolean;
  name: LangType;
  position_x?: string;
  position_y?: string;
  zip?: string;
  phone?: string;
  place_id: number;
  staff_count?: number | string;
  socials: SocialType[];
  payment_methods: PaymentMethod[];
  ssid_whitelist: string[];
  is_wifi_check_enabled: boolean;
  iiko_organization_id?: string;
};

export type FetchBranchesRequest = {
  name?: string;
  description?: string;
  address?: string;
  with_archive?: boolean;
} & Partial<BranchType> &
  PaginationRequest &
  CustomCacheRequest &
  SortRequest &
  WithArchiveRequest;

interface FetchBranchesResponse extends PaginationType {
  place: BranchType[];
}

const baseUrl = `${managerApiUrl}/place`;

export const fetchBranches = async (
  params: FetchBranchesRequest,
): Promise<FetchBranchesResponse> => {
  const { customCache, ...other } = params;
  const response: FetchBranchesResponse = await baseFetch(`${baseUrl}${buildParams(other)}`, {
    customCache,
  });

  return response;
};

export const postBranch = async (data: Partial<BranchType>): Promise<BranchType> => {
  const resp = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return resp;
};

export const putBranch = async (data: Partial<BranchType>): Promise<BranchType> => {
  const resp = await baseFetch(`${baseUrl}/${data.id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  return resp;
};

export const deleteBranch = async (id: string): Promise<void> => {
  await baseFetch(`${baseUrl}/${id}`, {
    method: 'DELETE',
  });
};

export const restoreBranch = async (id: string): Promise<void> => {
  await baseFetch(`${baseUrl}/${id}/restore`, {
    method: 'POST',
  });
};
